module.exports = "/assets/269802db6ad85a506bd10d9ca62b86ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/U6.png
// module id = 2999
// module chunks = 0